<template>
  <div>

     <div v-if="loading">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Role" :required="true">
              <input
                type="text"
                @blur="$v.role.role.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.role.role.$error }"
                v-model="role.role"
              />
              <div class="invalid-feedback" v-if="!$v.role.role.required">
                Please enter role
              </div>
            </form-group>

            <form-group label="Permissions" :required="true">
              <span v-for="item in permissions" :key="item.id">
              <b-form-checkbox
                v-model="role.permissions"
                :value="item.id"
              >
               {{ item.permission }}
              </b-form-checkbox>
              </span>
                <div class="text-danger" v-if="$v.role.permissions.$error">
                Please select permissions
              </div>
            </form-group>

         </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import roleRepo from '@/api/repos/roleRepo'
import { required } from 'vuelidate/lib/validators'
import formBase from '@/components/common/FormBase'
import formGroup from '@/components/common/FormGroup'
import permissionRepo from '@/api/repos/permissionRepo'

export default {
  components: {
    formBase,
    formGroup
  },

  validations: {
    role: {
      role: {
        required
      },
      permissions: {
        required
      }
    }
  },

  mounted () {
    this.getRole()
    this.getPermissions()
  },

  props: ['id'],

  data () {
    return {
      role: {
        role: '',
        permissions: []
      },
      permissions: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false
    }
  },

  methods: {
    async getPermissions () {
      let { data } = await permissionRepo.permissions()
      this.permissions = data.permissions
    },

    async getRole () {
      try {
        this.loading = true;
        let { data } = await roleRepo.get(this.id)
        this.role.role = data.role.role
        this.role.permissions = data.role_permissions.map(p => p.id)

      } catch (error) {
        console.log(error)
      } finally{
        this.loading = false
      }
    },
    async handleSubmit () {
      this.loading = true
      this.submitStatus = 'PENDING'
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        this.loading = false
      } else {
        try {
          await roleRepo.update(this.id, this.role)
          this.$emit("roleUpdated");
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
            console.log(this.errors)
               this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
            })
          }
        } finally {
          this.loading = false
          this.submitStatus = null
        }
      }
    }
  }
}
</script>

<style></style>
